import { SET_VOLUME } from "@actions/actionTypes"

export default function backgroundMusicVolumReducer(state = 0.2, action) {
    switch (action.type) {
        case SET_VOLUME:
            return action.payload
        default:
            return state;
    }
}